import { ConfirmDialog } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface BlankAspirationConfirmDialogProps {
    isOpen: boolean;
    isSaving: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const BlankAspirationConfirmDialog = ({
    isOpen,
    isSaving,
    onConfirm,
    onCancel,
}: BlankAspirationConfirmDialogProps) => {
    const { t } = useAmelioTranslations();

    return (
        <ConfirmDialog
            isOpen={isOpen}
            title={t('performanceProfile.growth.aspiration.form.blankSaveTitle')}
            message={t('performanceProfile.growth.aspiration.form.blankSaveMessage')}
            confirmLabel={t('performanceProfile.growth.aspiration.form.blankSaveConfirm')}
            cancelLabel={t('performanceProfile.growth.aspiration.form.blankSaveCancel')}
            onConfirm={onConfirm}
            onCancel={onCancel}
            isLoading={isSaving}
            dataTestId={'career-aspiration-blank-save-confirm'}
        />
    );
};
